import Page from "./cgreact-page";
import Component from "./cgreact-component";
import Application from "./cgreact-application";
import Signal from "./cgreact-signal";
import Layout from "./cgreact-layout";
import Modal from "./cgreact-modal";
import {affectStyle} from "./cgreact-anno";
import {CGReactPageException} from "./cgreact-exception";
import {copyObject, generateUUID, mergeObject, resetObject} from "./cgreact-util";

console.log(`
   ____    ____   ____                          _              ____                       
  / ___|  / ___| |  _ \\    ___    __ _    ___  | |_           / ___|   ___    _ __    ___ 
 | |     | |  _  | |_) |  / _ \\  / _\` |  / __| | __|  _____  | |      / _ \\  | '__|  / _ \\
 | |___  | |_| | |  _ <  |  __/ | (_| | | (__  | |_  |_____| | |___  | (_) | | |    |  __/
  \\____|  \\____| |_| \\_\\  \\___|  \\__,_|  \\___|  \\__|          \\____|  \\___/  |_|     \\___|
                                                                                           V${require("../package.json").version}`);
const CGReact = {
    CGReactApplication: Application,
    CGReactComponent: Component,
    CGReactLayout: Layout,
    CGReactModal: Modal,
    CGReactPage: Page,
    CGReactSignal: Signal,
    CGReactPageException:CGReactPageException,
    affectStyle: affectStyle,
    CGReactUtils: {
        generateUUID: generateUUID,
        resetObject: resetObject,
        copyObject: copyObject,
        mergeObject: mergeObject,
    }
};
typeof exports != "undefined" && (mergeObject(CGReact, exports));
typeof window != "undefined" && ((window as any).CGReact = CGReact);
export default CGReact;
